import { render } from "./GastosPage.vue?vue&type=template&id=3ccec523&scoped=true&ts=true"
import script from "./GastosPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./GastosPage.vue?vue&type=script&lang=ts&setup=true"

import "./GastosPage.vue?vue&type=style&index=0&id=3ccec523&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccec523"],['__file',"src/pages/financial/pages/GastosPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ccec523"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ccec523', __exports__)) {
    api.reload('3ccec523', __exports__)
  }
  
  module.hot.accept("./GastosPage.vue?vue&type=template&id=3ccec523&scoped=true&ts=true", () => {
    api.rerender('3ccec523', render)
  })

}


export default __exports__